var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconColumn3 = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M15,5.3h7.6c1.2,0,2.2,1,2.2,2.2v15.2c0,1.2-1,2.2-2.2,2.2H15 M15,5.3H7.4\n\tc-1.2,0-2.2,1-2.2,2.2v15.2c0,1.2,1,2.2,2.2,2.2H15" }),
            React.createElement("line", { x1: "11.7", y1: "8.3", x2: "11.7", y2: "21.8" }),
            React.createElement("line", { x1: "18.3", y1: "8.3", x2: "18.3", y2: "21.8" }))));
});
export default IconColumn3;
//# sourceMappingURL=IconColumn3.js.map